import { inject } from "@angular/core";
import { OrderAdDetailStatus } from "@app/core/enums/order-ad-detail-status";
import { StatusService } from "@app/shared/services/status.service";
import { OrderAdDetail } from "@core/models/order-ad-detail.model";

export class OrderLineDetailViewModel {
	isConfirmationDeadlineApproaching: boolean = false;
	isConfirmationDeadlinePassed: boolean = false;
	readonly orderLineModel: OrderAdDetail;

	constructor (orderAdDetail: OrderAdDetail) {
		//super();
		//Object.assign(this, orderAdDetail);
		let statusService = new StatusService();
		this.isConfirmationDeadlinePassed = statusService.doesAdDetailHaveStatus(orderAdDetail, OrderAdDetailStatus.PastConfirmDeadline);
		this.isConfirmationDeadlineApproaching = !this.isConfirmationDeadlinePassed && statusService.doesAdDetailHaveStatus(orderAdDetail, OrderAdDetailStatus.ConfirmDeadlineApproaching);
		this.orderLineModel = orderAdDetail;
	}
}
